import React from 'react';
import entityIcons from '@/constants/images';
import NameCellWrapper from '@/components/table/NameCellWrapper';
import EmailIcon from '@/components/EmailIcon';

const RequestedByCell = ({ user }) => (
  <NameCellWrapper className="aridhia-requested-by-cell" collapsing name={user.name}>
    <EmailIcon email={user.email} name={user.name} icon={entityIcons.user} />
  </NameCellWrapper>
);

export default RequestedByCell;
